import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Avatar,
  Divider,
  CardContent,
  CardActions,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Fab,
  ButtonBase,
  Paper,
  Grid,
  IconButton,
} from "@material-ui/core";
import moment from "moment";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  cancelButton: {
    color: "#dd4b39",
    margin: theme.spacing(1),
  },
}));

const AppointmentDetailsCalander = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "cancel-popover" : undefined;

  const appointmentList = useSelector((state) => state.appointment.appointmentList);
  let appointment= {};
  if(props.id){
    appointment = appointmentList.filter(appointment => appointment.id == props.id)[0];
  }

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
        <div
          variant="rounded"
          aria-describedby={id}
          onClick={handleClick}
        >
          <b>{props.timeText}</b>
          <i>{props.title}</i>
        
        </div>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth={'sm'}
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">
          {"Appointment detials"}
        </DialogTitle>
        <DialogContent>
          {appointment && appointment.status ? <>
              <Box
                display="flex"
                pt={1}
                pl={2}
                pr={2}
                fontWeight="fontWeightMedium"
                fontSize={13}
              >
                <Box flexGrow={1}>
                  <Box display="flex" color="primary.main">
                    <Box>
                      <i className="ri-calendar-fill"></i>
                    </Box>
                    
                    <Box pl={1}>{appointment && appointment.startDateTime && moment(appointment.startDateTime).format("YYYY-MM-DD hh:mm a")}</Box>
                    <Box pl={1}>{' To '}</Box>
                    <Box pl={1}>{appointment && appointment.endDateTime && moment(appointment.endDateTime).format("YYYY-MM-DD hh:mm a")}</Box>
                  </Box>
                </Box>
                <Box>{appointment && appointment.status}</Box>
              </Box>
              <Box m={2}>
                <Grid container spacing={3} alignItems="center" wrap="nowrap">
                  <Grid item>
                    {appointment && appointment.doctorDetails ? (
                      <Box display="flex" color="primary.main">
                        <Box>
                        <i className="fas fa-stethoscope"></i>
                        </Box>
                        <Box pl={1}>{appointment.doctorDetails.firstName +
                            " " +
                            appointment.doctorDetails.lastName}</Box>
                      </Box>
                    ) : null}
                    {appointment.patientDetails ? (
                      <Box display="flex" color="primary.main">
                        <Box>
                        <i className="fas fa-user-injured"></i>
                        </Box>
                        <Box pl={1}>{appointment.patientDetails.firstName +
                          " " +
                          appointment.patientDetails.lastName}</Box>
                      </Box>) : null}
                    <Divider
                          className={classes.divider}
                          orientation="horizontal"
                        />
                    <Typography gutterBottom variant="body3" color="textSecondary">
                      {appointment.consultationType}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Box overflow="hidden">
                      <Typography variant="body2" color="textSecondary">
                        {appointment.description ? appointment.description.substring(0, 100):''}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                
              </Box>
            
              </>:null}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AppointmentDetailsCalander;
